import { isValidCoordinate } from '@/profile/util/isValidCoordinate';

export const getLocationPath = (
  latitude: number | undefined,
  longitude: number | undefined,
  zoom: number,
  pathname: string,
  mapType: string | undefined
): string => {
  let path = '';
  const parts = pathname.split('/');

  // 範囲チェック
  if (
    longitude === undefined ||
    latitude === undefined ||
    isValidCoordinate(longitude, latitude) === false
  ) {
    // 緯度経度が異常の場合は、パスに追加しない
    if (mapType !== undefined && mapType !== '') {
      path = `/${mapType}/` + parts.slice(2).join('/');
    } else {
      path = '/' + parts.slice(1).join('/');
    }
  } else {
    // URLに埋め込む位置情報に変換(緯度経度は小数点以下7桁で四捨五入、倍率は2桁で四捨五入する)
    // NOTE: GooleMapと同様の仕様
    const locationPath = `@${Math.round(latitude * 1e7) / 1e7},${
      Math.round(longitude * 1e7) / 1e7
    },${Math.round(zoom * 1e2) / 1e2}z`;
    // パスに位置情報が含まれてるかチェック
    const regex = /^@.*z$/;
    if (parts.some((part) => regex.test(part))) {
      // すでにパスに位置情報が含まれている
      // パスに位置情報が含まれている場合はマップタイプを置き換える
      if (mapType !== undefined && mapType !== '') {
        parts[1] = mapType;
      }
      path = parts.join('/');
      // 位置情報を置き換える
      path = path.replace(/@.*?z/, locationPath);
    } else {
      // パスに位置情報が含まれていない場合は追加
      if (mapType !== undefined && mapType !== '') {
        path = `/${mapType}/${locationPath}/` + parts.slice(2).join('/');
      } else {
        path = `/${locationPath}/` + parts.slice(1).join('/');
      }
    }
  }

  return path;
};
